import { useState } from "react";
import { Link } from "react-router";
import { CLASE_BOTON_AUTH, MarcoAuth } from "../../components/auth/MarcoAuth";
import { Aviso, Campo } from "../../components/ui/primitivos";
import { authClient } from "../../lib/auth-client";

/**
 * «Olvidé mi contraseña» (ADR 0104 §5). Pública: se resuelve antes del chequeo
 * de sesión en `App`.
 *
 * El servidor contesta 200 exista o no la cuenta, así que el éxito nunca
 * confirma una dirección. Lo que sí se muestra son los errores reales (red,
 * 500): el cliente de Better Auth los DEVUELVE en `error`, no tira.
 */
const ERROR_GENERICO = "No pudimos enviar las instrucciones. Probá de nuevo en unos minutos.";

export function OlvideContrasenaPagina() {
  const [email, setEmail] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [enviado, setEnviado] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      const res = await authClient.requestPasswordReset({ email });
      if (res.error) setError(res.error.message || ERROR_GENERICO);
      else setEnviado(true);
    } catch {
      setError(ERROR_GENERICO);
    }
    setEnviando(false);
  }

  if (enviado) {
    return (
      <MarcoAuth titulo="Verificá tu email">
        <p className="text-sm text-neutral-600">
          Si existe una cuenta asociada a <strong className="text-neutral-900">{email}</strong>, vas
          a recibir un correo con las instrucciones para restablecer tu contraseña.
        </p>
        <p className="text-sm text-neutral-500">
          Puede tardar unos minutos en llegar. No te olvides de revisar la carpeta de spam.
        </p>
        <Link to="/" className="block text-center text-sm text-neutral-600 underline">
          Volver a iniciar sesión
        </Link>
      </MarcoAuth>
    );
  }

  return (
    <MarcoAuth
      titulo="Recuperar contraseña"
      subtitulo="Te enviamos las instrucciones para elegir una nueva."
    >
      <form onSubmit={onSubmit} className="space-y-5">
        <Campo
          etiqueta="Correo electrónico"
          type="email"
          required
          autoComplete="email"
          placeholder="tu@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {error ? <Aviso>{error}</Aviso> : null}
        <button type="submit" className={CLASE_BOTON_AUTH} disabled={enviando}>
          {enviando ? "Enviando..." : "Enviar instrucciones"}
        </button>
      </form>
      <p className="text-center text-sm text-neutral-600">
        ¿Ya te acordaste de tu contraseña?{" "}
        <Link to="/" className="underline">
          Volver a iniciar sesión
        </Link>
      </p>
    </MarcoAuth>
  );
}
